export const environmentDefaults = {
    debug: true,
    hmr: false,
    name: 'dev'
};
